import { ChartPadding } from 'eazychart-core';
import * as React from 'react';
import { useState } from 'react';

import { Input } from 'components/ui/input';

type PaddingControlsProps = {
  defaultPaddings: ChartPadding;
  onChange: (padding: ChartPadding) => void;
};

export const PaddingControls: React.FC<PaddingControlsProps> = ({
  defaultPaddings,
  onChange,
}) => {
  const [padding, setPadding] = useState<ChartPadding>(defaultPaddings);

  const updatePadding = (
    e: React.ChangeEvent<HTMLInputElement>,
    key: 'top' | 'left' | 'right' | 'bottom'
  ) => {
    const changedPadding = parseInt(e.target.value);
    const newPadding = {
      ...padding,
      [key]: !isNaN(changedPadding) ? changedPadding : 0,
    };
    setPadding({ ...newPadding });
    onChange(newPadding);
  };

  return (
    <div>
      <div className="flex flex-col items-center">
        <label htmlFor="padding-top">Top</label>
        <div className="w-1/2">
          <div className="flex">
            <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900">
              px
            </span>
            <Input
              id="padding-top"
              className="w-full rounded-l-none border-l-0 focus-visible:ring-0 focus-visible:ring-offset-0 h-8 px-2 text-xs"
              value={padding.top}
              onChange={(e) => updatePadding(e, 'top')}
            />
          </div>
        </div>
      </div>
      <div className="flex justify-around 	gap-6 mt-3">
        <div className="flex flex-col items-center">
          <label htmlFor="padding-left">Left</label>
          <div className="w-full  ">
            <div className="flex">
              <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900">
                px
              </span>
              <Input
                id="padding-left"
                className="w-full rounded-l-none border-l-0 focus-visible:ring-0 focus-visible:ring-offset-0 h-8 px-2 text-xs"
                value={padding.left}
                onChange={(e) => updatePadding(e, 'left')}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <label htmlFor="padding-right">Right</label>
          <div className="w-full">
            <div className="flex">
              <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900">
                px
              </span>
              <Input
                id="padding-right"
                className="w-full rounded-l-none border-l-0 focus-visible:ring-0 focus-visible:ring-offset-0 h-8 px-2 text-xs"
                value={padding.right}
                onChange={(e) => updatePadding(e, 'right')}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center mt-3">
        <label htmlFor="padding-bottom">Bottom</label>
        <div className="w-1/2">
          <div className="flex">
            <span className="inline-flex items-center rounded-l-md border border-r-0 border-gray-300 bg-gray-200 px-3 text-sm text-gray-900">
              px
            </span>
            <Input
              id="padding-bottom"
              className="w-full rounded-l-none border-l-0 focus-visible:ring-0 focus-visible:ring-offset-0 h-8 px-2 text-xs"
              value={padding.bottom}
              name="padding-bot"
              onChange={(e) => updatePadding(e, 'bottom')}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
